export const useScroll = () => {
  const scrollTop = () => {
    window.scroll({ top: 0, behavior: 'smooth' })
  }
  return {
    scrollTop,
  }
}
